import { render, staticRenderFns } from "./BrochureModal.vue?vue&type=template&id=31d67efe&scoped=true&"
import script from "./BrochureModal.vue?vue&type=script&lang=js&"
export * from "./BrochureModal.vue?vue&type=script&lang=js&"
import style0 from "./BrochureModal.vue?vue&type=style&index=0&id=31d67efe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d67efe",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FCImage: require('/opt/build/repo/apps/shop/components/FCImage.vue').default})
